import { zodResolver } from '@hookform/resolvers/zod'
import { useForm, UseFormProps } from 'react-hook-form'
import { z } from 'zod'

export const editSchema = z.object({
  demand_name: z
    .string()
    .min(1, 'O nome do diagnóstico é obrigatório.')
    .max(45, 'O nome do diagnóstico deve ter no máximo 45 caracteres.'),
})

export type EditFormData = z.infer<typeof editSchema>

export const useEditDiagnosisForm = (props?: UseFormProps<EditFormData>) => {
  const methods = useForm<EditFormData>({
    resolver: zodResolver(editSchema),
    ...props,
  })

  return methods
}
